import { publicAdminRoutes } from './admin';

export const publicRoutes = [...publicAdminRoutes];
